import axios from 'axios';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import './Footer.css';

const BASE_URL = 'https://testwire.wockhardt.com';

const Wockhardt_URL='https://vcqr.wockhardt.com/api/v1/dostemp';
const Employee_BASE_URL = 'https://e2api.wockhardt.com';
const jwt = localStorage.getItem('jwt'); 

function formatDate(dateString) {
  const parts = dateString.split(".");
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

const handleLogout = () => {
  localStorage.removeItem('jwt');
  window.location.href = '/login';
}



class GenerateEvisitingCard extends React.Component 
{
  state = {show:false,showDiv: false,data7:null, responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',empcode:''};

  fetchData0 = (userId) => 
  {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{headers: {Authorization: `Bearer ${jwt}`,'Content-Type': 'application/json'},})
    .then(res => {this.setState({ data0: res.data });console.log('API response user', res);})
    .catch(error => {console.error('API ERROR:', error);});
  };

  fetchData7 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`)
      .then(res => {
        this.setState({ data7: res.data });
      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };
  

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`)
      .then(res => {
        this.setState({ responseData: res.data });
        let id = res.data.id;
        let username = res.data.username;
        let email = res.data.email;
        let job = res.data.job;
        let empcode = res.data.empcode;
        let picture = res.data.picture.name;
        let pictureurl = res.data.picture.url;
        this.setState({ id });
        this.setState({ username });
        this.setState({ email });
        this.setState({ job });
        this.setState({ empcode });
        this.setState({ picture });
        this.setState({ pictureurl });

      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };

  componentDidMount() {
    this.fetchData7();
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    //console.log('id:', id);
    let username = jwtDataParsed.user.username;
    let email = jwtDataParsed.user.email;
    let job = jwtDataParsed.user.job;
    let empcode = jwtDataParsed.user.empcode;
    //console.log('empcode:', empcode);
    this.setState({ username });
    this.setState({ email });
    this.setState({ job });
    this.setState({ empcode });
    this.setState({ id });
    if (id) {
      this.fetchUserData(id);
      this.fetchData0(id);
      this.fetchEmployeeData(empcode);
    } else {
      console.error('id is undefined');
    }
    this.showModal();
  }

 showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  fetchEmployeeData = (empcode) => {
    axios.get(`${Employee_BASE_URL}/api/flutter/GetEmpDetails?empcode=${empcode}`)
      .then(res => {
        const employeeData = res.data[0];
        console.log('API Employees:', employeeData)
        this.setState({ employeeData: employeeData });
        let gender = employeeData.gender;
        let address = employeeData.address;
        let username = employeeData.empname;
        let positioN_CODE = employeeData.positioN_CODE;
        let position = employeeData.position;
        let empcode = employeeData.empcode;
        let area = employeeData.area;
        let jobrole = employeeData.jobrole;
        let subarea = employeeData.subarea;
        let subgroup = employeeData.subgroup;
        let doj = employeeData.doj;
        const inputDateString = employeeData.doj;
        const outputDateString = formatDate(inputDateString); // "11/16/1981"
        let dob = employeeData.dob;
        const inputDateStrings = employeeData.dob;
        const outputDateStrings = formatDate(inputDateStrings); // "11/16/1981"
        let companY_CODE = employeeData.companY_CODE;
        let cosT_CENTER = employeeData.cosT_CENTER;
        let worK_CNTRCT = employeeData.worK_CNTRCT;
        let organization = employeeData.organization;
        let communication = employeeData.communication;
        let flM_CODE = employeeData.flM_CODE;
        let reP_MGR = employeeData.reP_MGR;
        let refresH_DATE = employeeData.refresH_DATE;
        let peR_ADMIN = employeeData.peR_ADMIN;
        let paY_ADMIN = employeeData.paY_ADMIN;
        let f_NAME = employeeData.f_NAME;
        let l_NAME = employeeData.l_NAME;
        let orG_CODE = employeeData.orG_CODE;
        
        /* Added on17 June23 */
        let salutation = employeeData.salutation;
        let lastName = employeeData.lastName;
        let firstName = employeeData.firstName;
        let middleName = employeeData.middleName;
        let pan = employeeData.pan;
        let aadharNo = employeeData.aadharNo;
        let uan = employeeData.uan;
        let officialEmail = employeeData.officialEmail;
        let personalMobile = employeeData.personalMobile;
        let bankName = employeeData.bankName;
        let bankAccountNo = employeeData.bankAccountNo;
        let ifsc = employeeData.ifsc;
        let aadharName = employeeData.aadharName;
        let pfNo = employeeData.pfNo;
        let passportNo = employeeData.passportNo;
        let personalEmail = employeeData.personalEmail;
        let officeTelNo = employeeData.officeTelNo;
        let officeMobile = employeeData.officeMobile;
        let peR_ADMIN_EMAIL = res.data.peR_ADMIN_EMAIL;
        let peR_ADMIN_CODE = res.data.peR_ADMIN_CODE;
        let funC_HEAD_CODE = res.data.funC_HEAD_CODE;
        let funC_HEAD_EMAIL = res.data.funC_HEAD_EMAIL;
        /* Added on17 June23 End */

        /* Added this to pass userid in update api */
        let responseData = localStorage.getItem("responseData");
        this.setState({ responseData });
        let jwtDataParsed = JSON.parse(responseData);
        let userId = jwtDataParsed.user.id;
        //console.log('userId:', userId);
        /* Added this to pass userid in update api End */

        this.setState({ empcode });
        this.setState({ gender });
        this.setState({ address });
        this.setState({ username });
        console.log('usernamesss:', username);
        this.setState({ positioN_CODE });
        this.setState({ position });
        this.setState({ area });
        this.setState({ jobrole });
        this.setState({ subarea });
        this.setState({ subgroup });
        this.setState({ doj: formatDate(employeeData.doj) });
        this.setState({ dob: formatDate(employeeData.dob) });
        this.setState({ companY_CODE });
        this.setState({ cosT_CENTER });
        this.setState({ worK_CNTRCT });
        this.setState({ organization });
        this.setState({ communication });
        this.setState({ flM_CODE });
        this.setState({ reP_MGR });
        this.setState({ refresH_DATE });
        this.setState({ peR_ADMIN });
        this.setState({ paY_ADMIN });
        this.setState({ f_NAME });
        this.setState({ l_NAME });
        this.setState({ orG_CODE });
        
        /* Added on17 June23 */
        this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ pan });
        this.setState({ aadharNo });
        this.setState({ uan });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
        this.setState({ peR_ADMIN_EMAIL });
        this.setState({ peR_ADMIN_CODE });
        this.setState({ funC_HEAD_CODE });
        this.setState({ funC_HEAD_EMAIL });
        /* Added on17 June23 End */


          /* Prepare the data to be sent to the Strapi API*/
          const strapiData = {
            empcode: employeeData.empcode,
            gender: employeeData.gender,
            address: employeeData.address,
            username: employeeData.empname,
            positioN_CODE: employeeData.positioN_CODE,
            position: employeeData.position,
            area: employeeData.area,
            jobrole: employeeData.jobrole,
            subarea: employeeData.subarea,
            subgroup: employeeData.subgroup,
            doj: formatDate(employeeData.doj),
            dob: formatDate(employeeData.dob),
            companY_CODE: employeeData.companY_CODE,
            cosT_CENTER: employeeData.cosT_CENTER,
            worK_CNTRCT: employeeData.worK_CNTRCT,
            organization: employeeData.organization,
            communication: employeeData.communication,
            flM_CODE: employeeData.flM_CODE,
            reP_MGR: employeeData.reP_MGR,
            refresH_DATE: employeeData.refresH_DATE,
            peR_ADMIN: employeeData.peR_ADMIN,
            paY_ADMIN: employeeData.paY_ADMIN,
            f_NAME: employeeData.f_NAME,
            l_NAME: employeeData.l_NAME,
            orG_CODE: employeeData.orG_CODE,
            
            /* Added on17 June23 */
            salutation : employeeData.salutation,
            lastName : employeeData.lastName,
            firstName : employeeData.firstName,
            middleName : employeeData.middleName,
            pan : employeeData.pan,
            aadharNo : employeeData.aadharNo,
            uan : employeeData.uan,
            officialEmail : employeeData.officialEmail,
            personalMobile : employeeData.personalMobile,
            bankName : employeeData.bankName,
            bankAccountNo : employeeData.bankAccountNo,
            ifsc : employeeData.ifsc,
            aadharName : employeeData.aadharName,
            pfNo : employeeData.pfNo,
            passportNo : employeeData.passportNo,
            personalEmail : employeeData.personalEmail,
            officeTelNo : employeeData.officeTelNo,
            officeMobile : employeeData.officeMobile,
            peR_ADMIN_EMAIL : employeeData.peR_ADMIN_EMAIL,
            peR_ADMIN_CODE : employeeData.peR_ADMIN_CODE,
            funC_HEAD_CODE : employeeData.funC_HEAD_CODE,
            funC_HEAD_EMAIL : employeeData.funC_HEAD_EMAIL
            /* Added on17 June23 End */
          };
           //axios.put(`${BASE_URL}/api/users/4?empcode=${empcode}`, strapiData, {
            axios.put(`${BASE_URL}/api/users/${userId}?empcode=${empcode}`, strapiData, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            console.log('Data stored in Strapi:', res);
          })
          .catch(error => {
            console.error('Error storing data in Strapi:', error);
          });
      })
      .catch(error => {
        console.error('API error:', error);
      });
  };

  handleClick = () => {
    this.setState({
      showDiv: !this.state.showDiv
    });
  };

  handleGenerateQR = () => {
    const { userId} = this.state.data0;
console.log('Before API Hit VCQR');
    const payload = {data: this.state.data0};
	console.log(JSON.stringify(payload));

    console.log('URL:', `${Wockhardt_URL}`);
//console.log('Payload:', JSON.stringify(payload));
const durl = "https://vcqr.wockhardt.com/api/v1/dostemp";

axios.post(durl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        //console.log('Data sent successfully', response.data);
        alert('E-visiting card has been generated successfully and the link has been send to your official e-mail ID.');
        //window.location.href = BASE_URL; // Replace 'https://example.com' with your desired URL
        //window.location.href = 'https://wire.wockhardt.com';
      })
      .catch(error => {
        console.error('Error sending data', error); 
        
      });

  };
  

  /*logout = () => {
    fetch('${BASE_URL}api/auth/local/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('jwt')}`
      },
    })
      .then(res => res.json())
      .then(response => {
        localStorage.removeItem('jwt');
        this.setState({
          isAuthenticated: false
        });
      })
      .catch(error => console.log(error));
  }*/
  

  render() 
  {
    if (this.state.data7 === null || this.state.responseData === null) 
    {
      return <div>Loading...</div>;
    }

    const profleImage = this.state.pictureurl && this.state.pictureurl !== "null"? `${BASE_URL}${this.state.picctureurl}`: "/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z";

    return (
      <div className='bg-silver'>
        <div className='bg-white fixed top-0 right-0 left-0 z-20'>
          <div className="flex justify-between mb-2" > 
            <div className='mt-3 ml-5'>
              <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
            </div>
            <div className='flex'>
                  <ul class="navbar-list">
                     <li>
                     <img style={{marginTop: 5,marginRight: 5,cursor: 'pointer',borderWidth: 2,borderColor: '#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://wire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.pictureurl ? this.state.picture.alternativeText : 'Dummy Alt Text'} className="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white" onClick={this.handleClick}/>
  
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {/*{this.state.employeeData.username}*/} {this.state.username} </h5>
                                  <span class="text-white text-xs">{/*{this.state.employeeData.email}*/} {this.state.email}</span>
                                  <p class="text-white text-xs">Employee Code : {/*{this.state.employeeData.empcode}*/} {this.state.empcode}</p>
                                  {/*<p class="text-white text-xs">Position : {this.state.empcode} {this.state.employeeData.position}</p>*/}
                                 </div>

                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                    {/*<a class="iq-bg-danger iq-sign-btn" href="/login" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i class="ri-login-box-line ml-2"></i></a>*/} 
                                    {/* <a className="iq-bg-danger iq-sign-btn" role="button" onClick={this.handleGenerateQR} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Yes<i className="ri-login-box-line ml-2"></i></a>*/}
                                    <a class="iq-bg-danger iq-sign-btn" href="/generateqr" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate QR<i class="ri-login-box-line ml-2"></i></a>
                                    <a className="iq-bg-danger iq-sign-btn" href="#" role="button" onClick={handleLogout} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i className="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                  </ul>
            </div>
          </div>
          <div  style={{ display: 'flex', justifyContent:'space-around' }} >  
            {this.state.data7.data.map(item => (
              <div  className="mb-1">
                <div className="col-md-4" key={item.id}>
                    <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                </div>
             </div>
            ))}
          </div>
        </div> 

  <div className="bg-silver1">
  
      <section>   

        <Swiper>
                          <SwiperSlide>
                <div className="mt-32 rounded-2xl bg-newsblue p-3 mx-4 ">
                    <div style={{textAlign:'center', width:'100%'}}>
                  <p>Are you sure you want to Generate your eVisitingCard?</p>
                  <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'15%', display:'inline-block'}}>
                                    {/*<a class="iq-bg-danger iq-sign-btn" href="/login" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i class="ri-login-box-line ml-2"></i></a>*/}
                                    <a className="iq-bg-danger iq-sign-btn" role="button" onClick={this.handleGenerateQR} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Yes</a>
                                    <a class="iq-bg-danger iq-sign-btn" href="/" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >No</a>
                                 </div>
                                 </div>
                  
                </div>
              </SwiperSlide>
            
          </Swiper>  
                    
        </section>


        <section>
          <div className="footer">
            <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 pr-3 text-xs text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
          </div>
        </section>
  </div>
    </div>
  );
  }
};
  

export default GenerateEvisitingCard;

